import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref } from '@vue/composition-api'

//* Load filter options with promises
export const useServicioEscolarCatalogos = () => {
  const OrdeneStatusOptions = [{ label: 'Activa', value: 'ACT' }, { label: 'Cancelada', value: 'CAN' }, { label: 'Autorizada', value: 'AUT' }]

  const periodoOptions = ref([])
  const planOptions = ref([])

  const periodoOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 1, token: store.state.cuenta.session.token }, 'wsperiodo')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.data)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  const planOptionsPromise = () => new Promise((resolve, reject) => {
    getData({ action: 17, token: store.state.cuenta.session.token }, 'wscompras')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) resolve(response.data.datos)
        else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  // GET URL REGISTRO CIFRADO
  const getRegCifrado = Idpersona => new Promise((resolve, reject) => {
    const paramsRequest = {
      action: 31,
      personafk: Idpersona,
      token: store.state.cuenta.session.token,
    }
    getData(paramsRequest, 'wscompras')
      .then(response => {
        if (response.status !== 200) {
          reject(response.data.message)
        } else resolve(response.data)
      })
      .catch(err => { reject(err) })
  })

  return {
    // Promise fetch options
    periodoOptionsPromise,
    planOptionsPromise,
    getRegCifrado,

    // Options
    periodoOptions,
    planOptions,
    OrdeneStatusOptions,
  }
}

//* Method to fill param request from table solicitudes
export const configTableRequests = () => {
  let tableColumns = []
  if (store.state.cuenta.rolSelected.id !== 1) {
    // FOR ADMIN
    tableColumns = [
      {
        key: 'IdOrden', label: '#Id', sortable: true, stickyColumn: true,
      },
      { key: 'show_details', label: 'Detalles' },
      { key: 'opciones', label: 'ToDo' },
      { key: 'pagos', label: 'Aportaciones', sortable: true },
      { key: 'fullname', label: 'Nombre' },
      { key: 'referencia', label: 'referencia' },
      // { key: 'fecha', label: 'fecha', sortable: true },
      { key: 'matricula', label: 'matrícula', sortable: true },
      // { key: 'precioFinal', label: 'Aportación' }, '',
      // { key: 'descripcion', label: 'Beca Aplicada', sortable: true }, '',
      // { key: 'codigo', label: 'Cupón' },
      { key: 'limitePago', label: 'limitePago', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
    ]
  } else {
    // FOR ALUMNO
    tableColumns = [
      { key: 'id', label: 'orden', sortable: true },
      { key: 'opciones', label: 'Ver' },
      { key: 'pagos', label: 'Aportaciones' },
      { key: 'referencia', sortable: true },
      { key: 'fecha', sortable: true },
      { key: 'matricula', label: 'matrícula', sortable: true },
      { key: 'precioFinal', label: 'Aportación' },
      { key: 'limitePago' },
      { key: 'status', sortable: true },
    ]
  }
  //* Params to fill table data & filters
  const configRequest = ref({
    status: null, //* Filter
    wsParams: {
      action: 2, token: store.state.cuenta.session.token, rol: store.state.cuenta.rolSelected.id, plan: 0, cuatri: 0, finicio: null,
    }, //* Request params
    wsType: 'wscompras', //* WebService name
    filterGetter: 'compras/filterOrden', //* Getter function to filter data
  })

  return { tableColumns, configRequest }
}
